"use strict";
exports.__esModule = true;
exports.wait = void 0;
/**
 * Returns a promise which resolves after a given number of milliseconds,
 * using setTimeout.
 */
function wait(ms) {
    return new Promise(function (resolve) {
        return setTimeout(function () { return resolve(); }, ms);
    });
}
exports.wait = wait;
//# sourceMappingURL=wait.js.map